// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__16wWm","item":"PaymentsMobile_item__R39yR","label":"PaymentsMobile_label__2i8j4","amount":"PaymentsMobile_amount__3q1Pz"};